/* tslint:disable */
/* eslint-disable */
/**
 * ServiceTale API
 * This is ServiceTale API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@binhatch.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
export const AppointmentUpdateRequestNewStatusEnum = {
    Canceled: 'canceled',
    Confirmed: 'confirmed',
    NoShow: 'noShow'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ApprovalStatus = {
    Approved: 'approved',
    Rejected: 'rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChapterKind = {
    Dropoff: 'dropoff',
    CarReception: 'carReception',
    Inspection: 'inspection',
    Offer: 'offer',
    Work: 'work',
    WorkReception: 'workReception',
    Payment: 'payment',
    Handover: 'handover'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChapterState = {
    Pending: 'pending',
    WaitingUserIntervention: 'waiting_user_intervention',
    Final: 'final'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChapterStateRequest = {
    Draft: 'draft',
    Final: 'final'
};
export const CreateUserRequestRoleEnum = {
    Staff: 'staff',
    User: 'user'
};
/**
 *
 * @export
 * @enum {string}
 */
export const Priority = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
};
/**
 *
 * @export
 * @enum {string}
 */
export const RejectionCause = {
    EtaTooLong: 'etaTooLong',
    TooExpensive: 'tooExpensive',
    NotNeeded: 'notNeeded',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TaleStatus = {
    InProgress: 'inProgress',
    Completed: 'completed',
    Canceled: 'canceled',
    Refused: 'refused'
};
export const UserRoleEnum = {
    Staff: 'staff',
    User: 'user'
};
/**
 *
 * @export
 * @enum {string}
 */
export const WorkType = {
    Requested: 'requested',
    Additional: 'additional'
};
/**
 * AppointmentApi - axios parameter creator
 * @export
 */
export const AppointmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create appointment
         * @summary Create ad-hoc appointment
         * @param {string} id ID of workshop to return
         * @param {AppointmentCreationRequest} appointmentCreationRequest Appointment object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment: (id, appointmentCreationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createAppointment', 'id', id);
            // verify required parameter 'appointmentCreationRequest' is not null or undefined
            assertParamExists('createAppointment', 'appointmentCreationRequest', appointmentCreationRequest);
            const localVarPath = `/workshops/{id}/appointments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single appointment
         * @summary Get appointment by ID
         * @param {string} id ID of workshop to return the appointment for
         * @param {string} appointmentId ID of appointment to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentByID: (id, appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAppointmentByID', 'id', id);
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('getAppointmentByID', 'appointmentId', appointmentId);
            const localVarPath = `/workshops/{id}/appointments/{appointmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all appointments from the system that the user has access to, optionally filtered
         * @summary List appointments
         * @param {string} id ID of workshop to return appointments for
         * @param {string} [resourceId] ID of resource to return appointments for
         * @param {string} [serviceId] ID of service to return appointments for
         * @param {string} [startDate] Start date of appointments to return
         * @param {string} [endDate] End date of appointments to return
         * @param {ListAppointmentsStatusEnum} [status] Filter by status IN, BK, CN, RE, RS
         * @param {string} [bookedBy] email of user to return appointments for
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments: (id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listAppointments', 'id', id);
            const localVarPath = `/workshops/{id}/appointments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }
            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (bookedBy !== undefined) {
                localVarQueryParameter['bookedBy'] = bookedBy;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all resources
         * @summary List resources
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of resources to return
         * @param {number} [offset] number of resources to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopResources: (id, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopResources', 'id', id);
            const localVarPath = `/workshops/{id}/resources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all services
         * @summary List services
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of services to return
         * @param {number} [offset] number of services to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopServices: (id, limit, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopServices', 'id', id);
            const localVarPath = `/workshops/{id}/services`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update appointment
         * @summary Update appointment
         * @param {string} id ID of appointment to update
         * @param {string} appointmentId ID of appointment to return
         * @param {AppointmentUpdateRequest} appointmentUpdateRequest Appointment object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment: (id, appointmentId, appointmentUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAppointment', 'id', id);
            // verify required parameter 'appointmentId' is not null or undefined
            assertParamExists('updateAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'appointmentUpdateRequest' is not null or undefined
            assertParamExists('updateAppointment', 'appointmentUpdateRequest', appointmentUpdateRequest);
            const localVarPath = `/workshops/{id}/appointments/{appointmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"appointmentId"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(appointmentUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update location settings of current admin user
         * @summary Update location settings of current admin user
         * @param {string} id ID of workshop to return
         * @param {LocationUpdateModel} locationUpdateModel Location object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshop: (id, locationUpdateModel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWorkshop', 'id', id);
            // verify required parameter 'locationUpdateModel' is not null or undefined
            assertParamExists('updateWorkshop', 'locationUpdateModel', locationUpdateModel);
            const localVarPath = `/workshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(locationUpdateModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update service availability
         * @summary Update service availability
         * @param {string} id id of workshop to update
         * @param {string} serviceId id of service to update
         * @param {AvailabilityInputModel} availabilityInputModel Service object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshopServiceAvailability: (id, serviceId, availabilityInputModel, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWorkshopServiceAvailability', 'id', id);
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('updateWorkshopServiceAvailability', 'serviceId', serviceId);
            // verify required parameter 'availabilityInputModel' is not null or undefined
            assertParamExists('updateWorkshopServiceAvailability', 'availabilityInputModel', availabilityInputModel);
            const localVarPath = `/workshops/{id}/services/{serviceId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(availabilityInputModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppointmentApi - functional programming interface
 * @export
 */
export const AppointmentApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppointmentApiAxiosParamCreator(configuration);
    return {
        /**
         * Create appointment
         * @summary Create ad-hoc appointment
         * @param {string} id ID of workshop to return
         * @param {AppointmentCreationRequest} appointmentCreationRequest Appointment object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(id, appointmentCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAppointment(id, appointmentCreationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns a single appointment
         * @summary Get appointment by ID
         * @param {string} id ID of workshop to return the appointment for
         * @param {string} appointmentId ID of appointment to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentByID(id, appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppointmentByID(id, appointmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all appointments from the system that the user has access to, optionally filtered
         * @summary List appointments
         * @param {string} id ID of workshop to return appointments for
         * @param {string} [resourceId] ID of resource to return appointments for
         * @param {string} [serviceId] ID of service to return appointments for
         * @param {string} [startDate] Start date of appointments to return
         * @param {string} [endDate] End date of appointments to return
         * @param {ListAppointmentsStatusEnum} [status] Filter by status IN, BK, CN, RE, RS
         * @param {string} [bookedBy] email of user to return appointments for
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all resources
         * @summary List resources
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of resources to return
         * @param {number} [offset] number of resources to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopResources(id, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopResources(id, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all services
         * @summary List services
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of services to return
         * @param {number} [offset] number of services to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopServices(id, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopServices(id, limit, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update appointment
         * @summary Update appointment
         * @param {string} id ID of appointment to update
         * @param {string} appointmentId ID of appointment to return
         * @param {AppointmentUpdateRequest} appointmentUpdateRequest Appointment object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment(id, appointmentId, appointmentUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAppointment(id, appointmentId, appointmentUpdateRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update location settings of current admin user
         * @summary Update location settings of current admin user
         * @param {string} id ID of workshop to return
         * @param {LocationUpdateModel} locationUpdateModel Location object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshop(id, locationUpdateModel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWorkshop(id, locationUpdateModel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update service availability
         * @summary Update service availability
         * @param {string} id id of workshop to update
         * @param {string} serviceId id of service to update
         * @param {AvailabilityInputModel} availabilityInputModel Service object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppointmentApi - factory interface
 * @export
 */
export const AppointmentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppointmentApiFp(configuration);
    return {
        /**
         * Create appointment
         * @summary Create ad-hoc appointment
         * @param {string} id ID of workshop to return
         * @param {AppointmentCreationRequest} appointmentCreationRequest Appointment object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(id, appointmentCreationRequest, options) {
            return localVarFp.createAppointment(id, appointmentCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single appointment
         * @summary Get appointment by ID
         * @param {string} id ID of workshop to return the appointment for
         * @param {string} appointmentId ID of appointment to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentByID(id, appointmentId, options) {
            return localVarFp.getAppointmentByID(id, appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all appointments from the system that the user has access to, optionally filtered
         * @summary List appointments
         * @param {string} id ID of workshop to return appointments for
         * @param {string} [resourceId] ID of resource to return appointments for
         * @param {string} [serviceId] ID of service to return appointments for
         * @param {string} [startDate] Start date of appointments to return
         * @param {string} [endDate] End date of appointments to return
         * @param {ListAppointmentsStatusEnum} [status] Filter by status IN, BK, CN, RE, RS
         * @param {string} [bookedBy] email of user to return appointments for
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options) {
            return localVarFp.listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all resources
         * @summary List resources
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of resources to return
         * @param {number} [offset] number of resources to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopResources(id, limit, offset, options) {
            return localVarFp.listWorkshopResources(id, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all services
         * @summary List services
         * @param {string} id ID of workshop to return, for admins, this is the current workshop
         * @param {number} [limit] number of services to return
         * @param {number} [offset] number of services to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopServices(id, limit, offset, options) {
            return localVarFp.listWorkshopServices(id, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update appointment
         * @summary Update appointment
         * @param {string} id ID of appointment to update
         * @param {string} appointmentId ID of appointment to return
         * @param {AppointmentUpdateRequest} appointmentUpdateRequest Appointment object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointment(id, appointmentId, appointmentUpdateRequest, options) {
            return localVarFp.updateAppointment(id, appointmentId, appointmentUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update location settings of current admin user
         * @summary Update location settings of current admin user
         * @param {string} id ID of workshop to return
         * @param {LocationUpdateModel} locationUpdateModel Location object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshop(id, locationUpdateModel, options) {
            return localVarFp.updateWorkshop(id, locationUpdateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Update service availability
         * @summary Update service availability
         * @param {string} id id of workshop to update
         * @param {string} serviceId id of service to update
         * @param {AvailabilityInputModel} availabilityInputModel Service object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options) {
            return localVarFp.updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppointmentApi - object-oriented interface
 * @export
 * @class AppointmentApi
 * @extends {BaseAPI}
 */
export class AppointmentApi extends BaseAPI {
    /**
     * Create appointment
     * @summary Create ad-hoc appointment
     * @param {string} id ID of workshop to return
     * @param {AppointmentCreationRequest} appointmentCreationRequest Appointment object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    createAppointment(id, appointmentCreationRequest, options) {
        return AppointmentApiFp(this.configuration).createAppointment(id, appointmentCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single appointment
     * @summary Get appointment by ID
     * @param {string} id ID of workshop to return the appointment for
     * @param {string} appointmentId ID of appointment to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getAppointmentByID(id, appointmentId, options) {
        return AppointmentApiFp(this.configuration).getAppointmentByID(id, appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all appointments from the system that the user has access to, optionally filtered
     * @summary List appointments
     * @param {string} id ID of workshop to return appointments for
     * @param {string} [resourceId] ID of resource to return appointments for
     * @param {string} [serviceId] ID of service to return appointments for
     * @param {string} [startDate] Start date of appointments to return
     * @param {string} [endDate] End date of appointments to return
     * @param {ListAppointmentsStatusEnum} [status] Filter by status IN, BK, CN, RE, RS
     * @param {string} [bookedBy] email of user to return appointments for
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options) {
        return AppointmentApiFp(this.configuration).listAppointments(id, resourceId, serviceId, startDate, endDate, status, bookedBy, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all resources
     * @summary List resources
     * @param {string} id ID of workshop to return, for admins, this is the current workshop
     * @param {number} [limit] number of resources to return
     * @param {number} [offset] number of resources to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listWorkshopResources(id, limit, offset, options) {
        return AppointmentApiFp(this.configuration).listWorkshopResources(id, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all services
     * @summary List services
     * @param {string} id ID of workshop to return, for admins, this is the current workshop
     * @param {number} [limit] number of services to return
     * @param {number} [offset] number of services to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listWorkshopServices(id, limit, offset, options) {
        return AppointmentApiFp(this.configuration).listWorkshopServices(id, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update appointment
     * @summary Update appointment
     * @param {string} id ID of appointment to update
     * @param {string} appointmentId ID of appointment to return
     * @param {AppointmentUpdateRequest} appointmentUpdateRequest Appointment object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    updateAppointment(id, appointmentId, appointmentUpdateRequest, options) {
        return AppointmentApiFp(this.configuration).updateAppointment(id, appointmentId, appointmentUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update location settings of current admin user
     * @summary Update location settings of current admin user
     * @param {string} id ID of workshop to return
     * @param {LocationUpdateModel} locationUpdateModel Location object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    updateWorkshop(id, locationUpdateModel, options) {
        return AppointmentApiFp(this.configuration).updateWorkshop(id, locationUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update service availability
     * @summary Update service availability
     * @param {string} id id of workshop to update
     * @param {string} serviceId id of service to update
     * @param {AvailabilityInputModel} availabilityInputModel Service object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options) {
        return AppointmentApiFp(this.configuration).updateWorkshopServiceAvailability(id, serviceId, availabilityInputModel, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ListAppointmentsStatusEnum = {
    In: 'IN',
    Bk: 'BK',
    Cn: 'CN',
    Re: 'RE',
    Rs: 'RS'
};
/**
 * CarApi - axios parameter creator
 * @export
 */
export const CarApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create car
         * @summary Create car
         * @param {CarCreationRequest} carCreationRequest Car object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCar: (carCreationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carCreationRequest' is not null or undefined
            assertParamExists('createCar', 'carCreationRequest', carCreationRequest);
            const localVarPath = `/cars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(carCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [owner] ID of user to return cars for
         * @param {string} [search] search string to filter cars by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCars: (owner, search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CarApi - functional programming interface
 * @export
 */
export const CarApiFp = function (configuration) {
    const localVarAxiosParamCreator = CarApiAxiosParamCreator(configuration);
    return {
        /**
         * Create car
         * @summary Create car
         * @param {CarCreationRequest} carCreationRequest Car object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCar(carCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCar(carCreationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [owner] ID of user to return cars for
         * @param {string} [search] search string to filter cars by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCars(owner, search, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCars(owner, search, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CarApi - factory interface
 * @export
 */
export const CarApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CarApiFp(configuration);
    return {
        /**
         * Create car
         * @summary Create car
         * @param {CarCreationRequest} carCreationRequest Car object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCar(carCreationRequest, options) {
            return localVarFp.createCar(carCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [owner] ID of user to return cars for
         * @param {string} [search] search string to filter cars by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCars(owner, search, options) {
            return localVarFp.listCars(owner, search, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CarApi - object-oriented interface
 * @export
 * @class CarApi
 * @extends {BaseAPI}
 */
export class CarApi extends BaseAPI {
    /**
     * Create car
     * @summary Create car
     * @param {CarCreationRequest} carCreationRequest Car object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarApi
     */
    createCar(carCreationRequest, options) {
        return CarApiFp(this.configuration).createCar(carCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all cars of a user
     * @summary List cars of a user
     * @param {string} [owner] ID of user to return cars for
     * @param {string} [search] search string to filter cars by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarApi
     */
    listCars(owner, search, options) {
        return CarApiFp(this.configuration).listCars(owner, search, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CreditsApi - axios parameter creator
 * @export
 */
export const CreditsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a coupon with usage credits
         * @summary Create coupon
         * @param {CreateCouponRequest} createCouponRequest Create coupon request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon: (createCouponRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCouponRequest' is not null or undefined
            assertParamExists('createCoupon', 'createCouponRequest', createCouponRequest);
            const localVarPath = `/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CreditsApi - functional programming interface
 * @export
 */
export const CreditsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CreditsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a coupon with usage credits
         * @summary Create coupon
         * @param {CreateCouponRequest} createCouponRequest Create coupon request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon(createCouponRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCoupon(createCouponRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CreditsApi - factory interface
 * @export
 */
export const CreditsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CreditsApiFp(configuration);
    return {
        /**
         * Create a coupon with usage credits
         * @summary Create coupon
         * @param {CreateCouponRequest} createCouponRequest Create coupon request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon(createCouponRequest, options) {
            return localVarFp.createCoupon(createCouponRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CreditsApi - object-oriented interface
 * @export
 * @class CreditsApi
 * @extends {BaseAPI}
 */
export class CreditsApi extends BaseAPI {
    /**
     * Create a coupon with usage credits
     * @summary Create coupon
     * @param {CreateCouponRequest} createCouponRequest Create coupon request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditsApi
     */
    createCoupon(createCouponRequest, options) {
        return CreditsApiFp(this.configuration).createCoupon(createCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * RatingsApi - axios parameter creator
 * @export
 */
export const RatingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns ratings for workshop, optionally filtered
         * @summary List ratings for workshop
         * @param {string} id ID of workshop to return ratings for
         * @param {string} [paginationToken] This is the pagination token, from where start listing Orders from.
         * @param {number} [rating] Filter by rating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopRatings: (id, paginationToken, rating, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopRatings', 'id', id);
            const localVarPath = `/workshops/{id}/ratings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RatingsApi - functional programming interface
 * @export
 */
export const RatingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RatingsApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns ratings for workshop, optionally filtered
         * @summary List ratings for workshop
         * @param {string} id ID of workshop to return ratings for
         * @param {string} [paginationToken] This is the pagination token, from where start listing Orders from.
         * @param {number} [rating] Filter by rating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopRatings(id, paginationToken, rating, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopRatings(id, paginationToken, rating, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RatingsApi - factory interface
 * @export
 */
export const RatingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RatingsApiFp(configuration);
    return {
        /**
         * Returns ratings for workshop, optionally filtered
         * @summary List ratings for workshop
         * @param {string} id ID of workshop to return ratings for
         * @param {string} [paginationToken] This is the pagination token, from where start listing Orders from.
         * @param {number} [rating] Filter by rating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopRatings(id, paginationToken, rating, options) {
            return localVarFp.listWorkshopRatings(id, paginationToken, rating, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RatingsApi - object-oriented interface
 * @export
 * @class RatingsApi
 * @extends {BaseAPI}
 */
export class RatingsApi extends BaseAPI {
    /**
     * Returns ratings for workshop, optionally filtered
     * @summary List ratings for workshop
     * @param {string} id ID of workshop to return ratings for
     * @param {string} [paginationToken] This is the pagination token, from where start listing Orders from.
     * @param {number} [rating] Filter by rating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingsApi
     */
    listWorkshopRatings(id, paginationToken, rating, options) {
        return RatingsApiFp(this.configuration).listWorkshopRatings(id, paginationToken, rating, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TaleApi - axios parameter creator
 * @export
 */
export const TaleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add additional tale chapters to tale in case the current chapter of
         * @summary Add additional tale chapters to tale.
         * @param {string} id ID of tale to return
         * @param {TaleAdditionalChaptersRequest} [taleAdditionalChaptersRequest] Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaleAdditionalChapters: (id, taleAdditionalChaptersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTaleAdditionalChapters', 'id', id);
            const localVarPath = `/tales/{id}/chapters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleAdditionalChaptersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} id ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapter: (id, taleApprovalRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveTaleChapter', 'id', id);
            // verify required parameter 'taleApprovalRequest' is not null or undefined
            assertParamExists('approveTaleChapter', 'taleApprovalRequest', taleApprovalRequest);
            const localVarPath = `/tales/{id}/chapters/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleApprovalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} publicId public ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapterPublic: (publicId, taleApprovalRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('approveTaleChapterPublic', 'publicId', publicId);
            // verify required parameter 'taleApprovalRequest' is not null or undefined
            assertParamExists('approveTaleChapterPublic', 'taleApprovalRequest', taleApprovalRequest);
            const localVarPath = `/tales/{publicId}/preview/approve`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleApprovalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add additional tale chapter based on the current chapter of a tale. Currently supported only for offer chapters.
         * @summary Copy the current chapter of a tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTaleChapter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyTaleChapter', 'id', id);
            const localVarPath = `/tales/{id}/chapters/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create tale
         * @summary Create tale
         * @param {TaleCreationRequest | null} taleCreationRequest Tale object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTale: (taleCreationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taleCreationRequest' is not null or undefined
            assertParamExists('createTale', 'taleCreationRequest', taleCreationRequest);
            const localVarPath = `/tales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create tale template
         * @summary Create tale template
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaleTemplate: (taleTemplateCreationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taleTemplateCreationRequest' is not null or undefined
            assertParamExists('createTaleTemplate', 'taleTemplateCreationRequest', taleTemplateCreationRequest);
            const localVarPath = `/tales/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleTemplateCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create upload URL for tale
         * @summary Create upload URL for tale
         * @param {string} id ID of tale
         * @param {CreateUploadURLRequest} createUploadURLRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadURL: (id, createUploadURLRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createUploadURL', 'id', id);
            // verify required parameter 'createUploadURLRequest' is not null or undefined
            assertParamExists('createUploadURL', 'createUploadURLRequest', createUploadURLRequest);
            const localVarPath = `/tales/{id}/upload-urls`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUploadURLRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete tale template
         * @summary Delete tale template
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaleTemplate: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTaleTemplate', 'id', id);
            const localVarPath = `/tales/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single tale
         * @summary Get tale by ID
         * @param {string} id ID of tale to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleByID: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaleByID', 'id', id);
            const localVarPath = `/tales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns current tale chapter
         * @summary Get current tale chapter
         * @param {string} id ID of tale for which to return the current chapter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleCurrentChapter: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaleCurrentChapter', 'id', id);
            const localVarPath = `/tales/{id}/chapters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a tale preview
         * @summary Get tale preview by public ID
         * @param {string} publicId publicID of tale to preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTalePreviewByPublicID: (publicId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('getTalePreviewByPublicID', 'publicId', publicId);
            const localVarPath = `/tales/{publicId}/preview`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single tale template
         * @summary Get tale template by ID
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleTemplateByID: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaleTemplateByID', 'id', id);
            const localVarPath = `/tales/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Give feedback for tale
         * @summary Give feedback for tale
         * @param {string} publicId public ID of the tale
         * @param {TaleFeedbackRequest} taleFeedbackRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveFeedback: (publicId, taleFeedbackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('giveFeedback', 'publicId', publicId);
            // verify required parameter 'taleFeedbackRequest' is not null or undefined
            assertParamExists('giveFeedback', 'taleFeedbackRequest', taleFeedbackRequest);
            const localVarPath = `/tales/{publicId}/feedbacks`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleFeedbackRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all tale templates from the system that the user has access to
         * @summary List tale templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaleTemplates: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tales/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Notify subscribers about a new chapter
         * @summary Notify subscribers about a new chapter
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaleSubscribers: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notifyTaleSubscribers', 'id', id);
            const localVarPath = `/tales/{id}/notifications`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add additional persons to be notified about tale updates
         * @summary Add additional subscribers to tale
         * @param {string} id ID of tale
         * @param {TaleSubscriptionRequest} taleSubscriptionRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToTale: (id, taleSubscriptionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('subscribeToTale', 'id', id);
            // verify required parameter 'taleSubscriptionRequest' is not null or undefined
            assertParamExists('subscribeToTale', 'taleSubscriptionRequest', taleSubscriptionRequest);
            const localVarPath = `/tales/{id}/subscriptions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleSubscriptionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Unsubscribe from tale
         * @summary Unsubscribe from tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeFromTale: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unsubscribeFromTale', 'id', id);
            const localVarPath = `/tales/{id}/subscriptions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {TaleUpdateRequest} taleUpdateRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTale: (id, taleUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTale', 'id', id);
            // verify required parameter 'taleUpdateRequest' is not null or undefined
            assertParamExists('updateTale', 'taleUpdateRequest', taleUpdateRequest);
            const localVarPath = `/tales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update current chapter of tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {ChapterRequest} chapterRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleChapter: (id, chapterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaleChapter', 'id', id);
            // verify required parameter 'chapterRequest' is not null or undefined
            assertParamExists('updateTaleChapter', 'chapterRequest', chapterRequest);
            const localVarPath = `/tales/{id}/chapters`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(chapterRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update tale template
         * @summary Update tale template
         * @param {string} id ID of tale template to return
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleTemplate: (id, taleTemplateCreationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTaleTemplate', 'id', id);
            // verify required parameter 'taleTemplateCreationRequest' is not null or undefined
            assertParamExists('updateTaleTemplate', 'taleTemplateCreationRequest', taleTemplateCreationRequest);
            const localVarPath = `/tales/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(taleTemplateCreationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TaleApi - functional programming interface
 * @export
 */
export const TaleApiFp = function (configuration) {
    const localVarAxiosParamCreator = TaleApiAxiosParamCreator(configuration);
    return {
        /**
         * Add additional tale chapters to tale in case the current chapter of
         * @summary Add additional tale chapters to tale.
         * @param {string} id ID of tale to return
         * @param {TaleAdditionalChaptersRequest} [taleAdditionalChaptersRequest] Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} id ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapter(id, taleApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveTaleChapter(id, taleApprovalRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} publicId public ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapterPublic(publicId, taleApprovalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveTaleChapterPublic(publicId, taleApprovalRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Add additional tale chapter based on the current chapter of a tale. Currently supported only for offer chapters.
         * @summary Copy the current chapter of a tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTaleChapter(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.copyTaleChapter(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create tale
         * @summary Create tale
         * @param {TaleCreationRequest | null} taleCreationRequest Tale object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTale(taleCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTale(taleCreationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create tale template
         * @summary Create tale template
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaleTemplate(taleTemplateCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTaleTemplate(taleTemplateCreationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create upload URL for tale
         * @summary Create upload URL for tale
         * @param {string} id ID of tale
         * @param {CreateUploadURLRequest} createUploadURLRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadURL(id, createUploadURLRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUploadURL(id, createUploadURLRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Delete tale template
         * @summary Delete tale template
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaleTemplate(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTaleTemplate(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns a single tale
         * @summary Get tale by ID
         * @param {string} id ID of tale to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleByID(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaleByID(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns current tale chapter
         * @summary Get current tale chapter
         * @param {string} id ID of tale for which to return the current chapter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleCurrentChapter(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaleCurrentChapter(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns a tale preview
         * @summary Get tale preview by public ID
         * @param {string} publicId publicID of tale to preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTalePreviewByPublicID(publicId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTalePreviewByPublicID(publicId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns a single tale template
         * @summary Get tale template by ID
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleTemplateByID(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaleTemplateByID(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Give feedback for tale
         * @summary Give feedback for tale
         * @param {string} publicId public ID of the tale
         * @param {TaleFeedbackRequest} taleFeedbackRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveFeedback(publicId, taleFeedbackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.giveFeedback(publicId, taleFeedbackRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all tale templates from the system that the user has access to
         * @summary List tale templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaleTemplates(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTaleTemplates(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Notify subscribers about a new chapter
         * @summary Notify subscribers about a new chapter
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaleSubscribers(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notifyTaleSubscribers(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Add additional persons to be notified about tale updates
         * @summary Add additional subscribers to tale
         * @param {string} id ID of tale
         * @param {TaleSubscriptionRequest} taleSubscriptionRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToTale(id, taleSubscriptionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.subscribeToTale(id, taleSubscriptionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Unsubscribe from tale
         * @summary Unsubscribe from tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeFromTale(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unsubscribeFromTale(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {TaleUpdateRequest} taleUpdateRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTale(id, taleUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTale(id, taleUpdateRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update current chapter of tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {ChapterRequest} chapterRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleChapter(id, chapterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTaleChapter(id, chapterRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update tale template
         * @summary Update tale template
         * @param {string} id ID of tale template to return
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleTemplate(id, taleTemplateCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTaleTemplate(id, taleTemplateCreationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TaleApi - factory interface
 * @export
 */
export const TaleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TaleApiFp(configuration);
    return {
        /**
         * Add additional tale chapters to tale in case the current chapter of
         * @summary Add additional tale chapters to tale.
         * @param {string} id ID of tale to return
         * @param {TaleAdditionalChaptersRequest} [taleAdditionalChaptersRequest] Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options) {
            return localVarFp.addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} id ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapter(id, taleApprovalRequest, options) {
            return localVarFp.approveTaleChapter(id, taleApprovalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve current tale chapter
         * @summary Approve current tale chapter
         * @param {string} publicId public ID of tale to return
         * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTaleChapterPublic(publicId, taleApprovalRequest, options) {
            return localVarFp.approveTaleChapterPublic(publicId, taleApprovalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add additional tale chapter based on the current chapter of a tale. Currently supported only for offer chapters.
         * @summary Copy the current chapter of a tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyTaleChapter(id, options) {
            return localVarFp.copyTaleChapter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tale
         * @summary Create tale
         * @param {TaleCreationRequest | null} taleCreationRequest Tale object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTale(taleCreationRequest, options) {
            return localVarFp.createTale(taleCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tale template
         * @summary Create tale template
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTaleTemplate(taleTemplateCreationRequest, options) {
            return localVarFp.createTaleTemplate(taleTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create upload URL for tale
         * @summary Create upload URL for tale
         * @param {string} id ID of tale
         * @param {CreateUploadURLRequest} createUploadURLRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUploadURL(id, createUploadURLRequest, options) {
            return localVarFp.createUploadURL(id, createUploadURLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete tale template
         * @summary Delete tale template
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTaleTemplate(id, options) {
            return localVarFp.deleteTaleTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single tale
         * @summary Get tale by ID
         * @param {string} id ID of tale to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleByID(id, options) {
            return localVarFp.getTaleByID(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns current tale chapter
         * @summary Get current tale chapter
         * @param {string} id ID of tale for which to return the current chapter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleCurrentChapter(id, options) {
            return localVarFp.getTaleCurrentChapter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a tale preview
         * @summary Get tale preview by public ID
         * @param {string} publicId publicID of tale to preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTalePreviewByPublicID(publicId, options) {
            return localVarFp.getTalePreviewByPublicID(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single tale template
         * @summary Get tale template by ID
         * @param {string} id ID of tale template to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaleTemplateByID(id, options) {
            return localVarFp.getTaleTemplateByID(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Give feedback for tale
         * @summary Give feedback for tale
         * @param {string} publicId public ID of the tale
         * @param {TaleFeedbackRequest} taleFeedbackRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveFeedback(publicId, taleFeedbackRequest, options) {
            return localVarFp.giveFeedback(publicId, taleFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all tale templates from the system that the user has access to
         * @summary List tale templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaleTemplates(options) {
            return localVarFp.listTaleTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * Notify subscribers about a new chapter
         * @summary Notify subscribers about a new chapter
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaleSubscribers(id, options) {
            return localVarFp.notifyTaleSubscribers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Add additional persons to be notified about tale updates
         * @summary Add additional subscribers to tale
         * @param {string} id ID of tale
         * @param {TaleSubscriptionRequest} taleSubscriptionRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToTale(id, taleSubscriptionRequest, options) {
            return localVarFp.subscribeToTale(id, taleSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unsubscribe from tale
         * @summary Unsubscribe from tale
         * @param {string} id ID of tale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeFromTale(id, options) {
            return localVarFp.unsubscribeFromTale(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {TaleUpdateRequest} taleUpdateRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTale(id, taleUpdateRequest, options) {
            return localVarFp.updateTale(id, taleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update current chapter of tale
         * @summary Update tale
         * @param {string} id ID of tale to return
         * @param {ChapterRequest} chapterRequest Tale object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleChapter(id, chapterRequest, options) {
            return localVarFp.updateTaleChapter(id, chapterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update tale template
         * @summary Update tale template
         * @param {string} id ID of tale template to return
         * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be updated in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaleTemplate(id, taleTemplateCreationRequest, options) {
            return localVarFp.updateTaleTemplate(id, taleTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaleApi - object-oriented interface
 * @export
 * @class TaleApi
 * @extends {BaseAPI}
 */
export class TaleApi extends BaseAPI {
    /**
     * Add additional tale chapters to tale in case the current chapter of
     * @summary Add additional tale chapters to tale.
     * @param {string} id ID of tale to return
     * @param {TaleAdditionalChaptersRequest} [taleAdditionalChaptersRequest] Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options) {
        return TaleApiFp(this.configuration).addTaleAdditionalChapters(id, taleAdditionalChaptersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Approve current tale chapter
     * @summary Approve current tale chapter
     * @param {string} id ID of tale to return
     * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    approveTaleChapter(id, taleApprovalRequest, options) {
        return TaleApiFp(this.configuration).approveTaleChapter(id, taleApprovalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Approve current tale chapter
     * @summary Approve current tale chapter
     * @param {string} publicId public ID of tale to return
     * @param {TaleApprovalRequest} taleApprovalRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    approveTaleChapterPublic(publicId, taleApprovalRequest, options) {
        return TaleApiFp(this.configuration).approveTaleChapterPublic(publicId, taleApprovalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Add additional tale chapter based on the current chapter of a tale. Currently supported only for offer chapters.
     * @summary Copy the current chapter of a tale
     * @param {string} id ID of tale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    copyTaleChapter(id, options) {
        return TaleApiFp(this.configuration).copyTaleChapter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create tale
     * @summary Create tale
     * @param {TaleCreationRequest | null} taleCreationRequest Tale object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    createTale(taleCreationRequest, options) {
        return TaleApiFp(this.configuration).createTale(taleCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create tale template
     * @summary Create tale template
     * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    createTaleTemplate(taleTemplateCreationRequest, options) {
        return TaleApiFp(this.configuration).createTaleTemplate(taleTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create upload URL for tale
     * @summary Create upload URL for tale
     * @param {string} id ID of tale
     * @param {CreateUploadURLRequest} createUploadURLRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    createUploadURL(id, createUploadURLRequest, options) {
        return TaleApiFp(this.configuration).createUploadURL(id, createUploadURLRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete tale template
     * @summary Delete tale template
     * @param {string} id ID of tale template to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    deleteTaleTemplate(id, options) {
        return TaleApiFp(this.configuration).deleteTaleTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single tale
     * @summary Get tale by ID
     * @param {string} id ID of tale to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    getTaleByID(id, options) {
        return TaleApiFp(this.configuration).getTaleByID(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns current tale chapter
     * @summary Get current tale chapter
     * @param {string} id ID of tale for which to return the current chapter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    getTaleCurrentChapter(id, options) {
        return TaleApiFp(this.configuration).getTaleCurrentChapter(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a tale preview
     * @summary Get tale preview by public ID
     * @param {string} publicId publicID of tale to preview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    getTalePreviewByPublicID(publicId, options) {
        return TaleApiFp(this.configuration).getTalePreviewByPublicID(publicId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single tale template
     * @summary Get tale template by ID
     * @param {string} id ID of tale template to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    getTaleTemplateByID(id, options) {
        return TaleApiFp(this.configuration).getTaleTemplateByID(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Give feedback for tale
     * @summary Give feedback for tale
     * @param {string} publicId public ID of the tale
     * @param {TaleFeedbackRequest} taleFeedbackRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    giveFeedback(publicId, taleFeedbackRequest, options) {
        return TaleApiFp(this.configuration).giveFeedback(publicId, taleFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all tale templates from the system that the user has access to
     * @summary List tale templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    listTaleTemplates(options) {
        return TaleApiFp(this.configuration).listTaleTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Notify subscribers about a new chapter
     * @summary Notify subscribers about a new chapter
     * @param {string} id ID of tale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    notifyTaleSubscribers(id, options) {
        return TaleApiFp(this.configuration).notifyTaleSubscribers(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Add additional persons to be notified about tale updates
     * @summary Add additional subscribers to tale
     * @param {string} id ID of tale
     * @param {TaleSubscriptionRequest} taleSubscriptionRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    subscribeToTale(id, taleSubscriptionRequest, options) {
        return TaleApiFp(this.configuration).subscribeToTale(id, taleSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unsubscribe from tale
     * @summary Unsubscribe from tale
     * @param {string} id ID of tale
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    unsubscribeFromTale(id, options) {
        return TaleApiFp(this.configuration).unsubscribeFromTale(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update tale
     * @summary Update tale
     * @param {string} id ID of tale to return
     * @param {TaleUpdateRequest} taleUpdateRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    updateTale(id, taleUpdateRequest, options) {
        return TaleApiFp(this.configuration).updateTale(id, taleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update current chapter of tale
     * @summary Update tale
     * @param {string} id ID of tale to return
     * @param {ChapterRequest} chapterRequest Tale object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    updateTaleChapter(id, chapterRequest, options) {
        return TaleApiFp(this.configuration).updateTaleChapter(id, chapterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update tale template
     * @summary Update tale template
     * @param {string} id ID of tale template to return
     * @param {TaleTemplateCreationRequest} taleTemplateCreationRequest Tale template object that needs to be updated in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaleApi
     */
    updateTaleTemplate(id, taleTemplateCreationRequest, options) {
        return TaleApiFp(this.configuration).updateTaleTemplate(id, taleTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordRequest} changePasswordRequest Change password request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: (changePasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest);
            const localVarPath = `/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Confirms sign-up for account
         * @summary Confirm user account
         * @param {string} id ID of workshop to return
         * @param {WorkshopUserConfirmationRequest} workshopUserConfirmationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmWorkshopUser: (id, workshopUserConfirmationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmWorkshopUser', 'id', id);
            // verify required parameter 'workshopUserConfirmationRequest' is not null or undefined
            assertParamExists('confirmWorkshopUser', 'workshopUserConfirmationRequest', workshopUserConfirmationRequest);
            const localVarPath = `/workshops/{id}/users/confirmations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(workshopUserConfirmationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add note about workshop user
         * @summary Add note about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to add note about
         * @param {CreateUserNotesRequest} createUserNotesRequest Notes object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUserNotes: (id, userId, createUserNotesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createWorkshopUserNotes', 'id', id);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createWorkshopUserNotes', 'userId', userId);
            // verify required parameter 'createUserNotesRequest' is not null or undefined
            assertParamExists('createWorkshopUserNotes', 'createUserNotesRequest', createUserNotesRequest);
            const localVarPath = `/workshops/{id}/users/{userId}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserNotesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get notes about workshop user
         * @summary Get notes about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to get notes about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopUserNotes: (id, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkshopUserNotes', 'id', id);
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWorkshopUserNotes', 'userId', userId);
            const localVarPath = `/workshops/{id}/users/{userId}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] search string to filter cars by
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserCars: (paginationToken, search, carIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/cars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (carIds !== undefined) {
                localVarQueryParameter['carIds'] = carIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all tales of a user
         * @summary List tales of a user
         * @param {TaleStatus} [status]
         * @param {string} [workshopId]
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTales: (status, workshopId, search, paginationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/tales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (workshopId !== undefined) {
                localVarQueryParameter['workshopId'] = workshopId;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordRequest} changePasswordRequest Change password request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Confirms sign-up for account
         * @summary Confirm user account
         * @param {string} id ID of workshop to return
         * @param {WorkshopUserConfirmationRequest} workshopUserConfirmationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmWorkshopUser(id, workshopUserConfirmationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmWorkshopUser(id, workshopUserConfirmationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Add note about workshop user
         * @summary Add note about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to add note about
         * @param {CreateUserNotesRequest} createUserNotesRequest Notes object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUserNotes(id, userId, createUserNotesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWorkshopUserNotes(id, userId, createUserNotesRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get notes about workshop user
         * @summary Get notes about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to get notes about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopUserNotes(id, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkshopUserNotes(id, userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] search string to filter cars by
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserCars(paginationToken, search, carIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUserCars(paginationToken, search, carIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all tales of a user
         * @summary List tales of a user
         * @param {TaleStatus} [status]
         * @param {string} [workshopId]
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTales(status, workshopId, search, paginationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUserTales(status, workshopId, search, paginationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Change password
         * @summary Change password
         * @param {ChangePasswordRequest} changePasswordRequest Change password request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest, options) {
            return localVarFp.changePassword(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirms sign-up for account
         * @summary Confirm user account
         * @param {string} id ID of workshop to return
         * @param {WorkshopUserConfirmationRequest} workshopUserConfirmationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmWorkshopUser(id, workshopUserConfirmationRequest, options) {
            return localVarFp.confirmWorkshopUser(id, workshopUserConfirmationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add note about workshop user
         * @summary Add note about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to add note about
         * @param {CreateUserNotesRequest} createUserNotesRequest Notes object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUserNotes(id, userId, createUserNotesRequest, options) {
            return localVarFp.createWorkshopUserNotes(id, userId, createUserNotesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get notes about workshop user
         * @summary Get notes about workshop user
         * @param {string} id ID of workshop
         * @param {string} userId ID of user to get notes about
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopUserNotes(id, userId, options) {
            return localVarFp.getWorkshopUserNotes(id, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all cars of a user
         * @summary List cars of a user
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] search string to filter cars by
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserCars(paginationToken, search, carIds, options) {
            return localVarFp.listUserCars(paginationToken, search, carIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all tales of a user
         * @summary List tales of a user
         * @param {TaleStatus} [status]
         * @param {string} [workshopId]
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTales(status, workshopId, search, paginationToken, options) {
            return localVarFp.listUserTales(status, workshopId, search, paginationToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Change password
     * @summary Change password
     * @param {ChangePasswordRequest} changePasswordRequest Change password request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    changePassword(changePasswordRequest, options) {
        return UsersApiFp(this.configuration).changePassword(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Confirms sign-up for account
     * @summary Confirm user account
     * @param {string} id ID of workshop to return
     * @param {WorkshopUserConfirmationRequest} workshopUserConfirmationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    confirmWorkshopUser(id, workshopUserConfirmationRequest, options) {
        return UsersApiFp(this.configuration).confirmWorkshopUser(id, workshopUserConfirmationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Add note about workshop user
     * @summary Add note about workshop user
     * @param {string} id ID of workshop
     * @param {string} userId ID of user to add note about
     * @param {CreateUserNotesRequest} createUserNotesRequest Notes object that needs to be added to the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    createWorkshopUserNotes(id, userId, createUserNotesRequest, options) {
        return UsersApiFp(this.configuration).createWorkshopUserNotes(id, userId, createUserNotesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get notes about workshop user
     * @summary Get notes about workshop user
     * @param {string} id ID of workshop
     * @param {string} userId ID of user to get notes about
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getWorkshopUserNotes(id, userId, options) {
        return UsersApiFp(this.configuration).getWorkshopUserNotes(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all cars of a user
     * @summary List cars of a user
     * @param {string} [paginationToken] This is the pagination token
     * @param {string} [search] search string to filter cars by
     * @param {string} [carIds] comma separated list of car IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listUserCars(paginationToken, search, carIds, options) {
        return UsersApiFp(this.configuration).listUserCars(paginationToken, search, carIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all tales of a user
     * @summary List tales of a user
     * @param {TaleStatus} [status]
     * @param {string} [workshopId]
     * @param {string} [search]
     * @param {string} [paginationToken] This is the pagination token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    listUserTales(status, workshopId, search, paginationToken, options) {
        return UsersApiFp(this.configuration).listUserTales(status, workshopId, search, paginationToken, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VinApi - axios parameter creator
 * @export
 */
export const VinApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a single car
         * @summary Get car by VIN
         * @param {string} vin VIN to analyze
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarInfoByVIN: (vin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vin' is not null or undefined
            assertParamExists('getCarInfoByVIN', 'vin', vin);
            const localVarPath = `/vin/{vin}`
                .replace(`{${"vin"}}`, encodeURIComponent(String(vin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VinApi - functional programming interface
 * @export
 */
export const VinApiFp = function (configuration) {
    const localVarAxiosParamCreator = VinApiAxiosParamCreator(configuration);
    return {
        /**
         * Returns a single car
         * @summary Get car by VIN
         * @param {string} vin VIN to analyze
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarInfoByVIN(vin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCarInfoByVIN(vin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VinApi - factory interface
 * @export
 */
export const VinApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VinApiFp(configuration);
    return {
        /**
         * Returns a single car
         * @summary Get car by VIN
         * @param {string} vin VIN to analyze
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarInfoByVIN(vin, options) {
            return localVarFp.getCarInfoByVIN(vin, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VinApi - object-oriented interface
 * @export
 * @class VinApi
 * @extends {BaseAPI}
 */
export class VinApi extends BaseAPI {
    /**
     * Returns a single car
     * @summary Get car by VIN
     * @param {string} vin VIN to analyze
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinApi
     */
    getCarInfoByVIN(vin, options) {
        return VinApiFp(this.configuration).getCarInfoByVIN(vin, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Webhook for processing new job events in Dolby
         * @summary Process new Dolby job events
         * @param {DolbyJobRequest} dolbyJobRequest Dolby job webhook. Reference https://docs.dolby.io/media-apis/docs/webhooks-and-callbacks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDolbyJob: (dolbyJobRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dolbyJobRequest' is not null or undefined
            assertParamExists('processDolbyJob', 'dolbyJobRequest', dolbyJobRequest);
            const localVarPath = `/webhooks/dolby/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dolbyJobRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Webhook for processing new events in Stripe
         * @summary Process new Stripe events
         * @param {StripeEventRequest} stripeEventRequest Stripe event webhook. Reference https://stripe.com/docs/api/events/types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStripeEvent: (stripeEventRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'stripeEventRequest' is not null or undefined
            assertParamExists('processStripeEvent', 'stripeEventRequest', stripeEventRequest);
            const localVarPath = `/webhooks/stripe/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(stripeEventRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function (configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration);
    return {
        /**
         * Webhook for processing new job events in Dolby
         * @summary Process new Dolby job events
         * @param {DolbyJobRequest} dolbyJobRequest Dolby job webhook. Reference https://docs.dolby.io/media-apis/docs/webhooks-and-callbacks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDolbyJob(dolbyJobRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.processDolbyJob(dolbyJobRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Webhook for processing new events in Stripe
         * @summary Process new Stripe events
         * @param {StripeEventRequest} stripeEventRequest Stripe event webhook. Reference https://stripe.com/docs/api/events/types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStripeEvent(stripeEventRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.processStripeEvent(stripeEventRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WebhookApiFp(configuration);
    return {
        /**
         * Webhook for processing new job events in Dolby
         * @summary Process new Dolby job events
         * @param {DolbyJobRequest} dolbyJobRequest Dolby job webhook. Reference https://docs.dolby.io/media-apis/docs/webhooks-and-callbacks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDolbyJob(dolbyJobRequest, options) {
            return localVarFp.processDolbyJob(dolbyJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Webhook for processing new events in Stripe
         * @summary Process new Stripe events
         * @param {StripeEventRequest} stripeEventRequest Stripe event webhook. Reference https://stripe.com/docs/api/events/types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStripeEvent(stripeEventRequest, options) {
            return localVarFp.processStripeEvent(stripeEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * Webhook for processing new job events in Dolby
     * @summary Process new Dolby job events
     * @param {DolbyJobRequest} dolbyJobRequest Dolby job webhook. Reference https://docs.dolby.io/media-apis/docs/webhooks-and-callbacks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    processDolbyJob(dolbyJobRequest, options) {
        return WebhookApiFp(this.configuration).processDolbyJob(dolbyJobRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Webhook for processing new events in Stripe
     * @summary Process new Stripe events
     * @param {StripeEventRequest} stripeEventRequest Stripe event webhook. Reference https://stripe.com/docs/api/events/types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    processStripeEvent(stripeEventRequest, options) {
        return WebhookApiFp(this.configuration).processStripeEvent(stripeEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WorkshopApi - axios parameter creator
 * @export
 */
export const WorkshopApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create checkout session
         * @summary Create checkout session
         * @param {string} id ID of workshop
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest Create checkout session request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: (id, createCheckoutSessionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCheckoutSession', 'id', id);
            // verify required parameter 'createCheckoutSessionRequest' is not null or undefined
            assertParamExists('createCheckoutSession', 'createCheckoutSessionRequest', createCheckoutSessionRequest);
            const localVarPath = `/workshops/{id}/checkout-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createCheckoutSessionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * enrolls a new workshop in the system
         * @summary Register workshop
         * @param {CreateWorkshopRequest} createWorkshopRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshop: (createWorkshopRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createWorkshopRequest' is not null or undefined
            assertParamExists('createWorkshop', 'createWorkshopRequest', createWorkshopRequest);
            const localVarPath = `/workshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkshopRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create workshop user
         * @summary create workshop user
         * @param {string} id ID of workshop
         * @param {CreateUserRequest} createUserRequest User creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUser: (id, createUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createWorkshopUser', 'id', id);
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createWorkshopUser', 'createUserRequest', createUserRequest);
            const localVarPath = `/workshops/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get workshop\'s invoices
         * @summary Get workshop\'s invoices
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoices', 'id', id);
            const localVarPath = `/workshops/{id}/invoices`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get workshop\'s upcoming invoice
         * @summary Get workshop\'s upcoming invoice
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUpcomingInvoice', 'id', id);
            const localVarPath = `/workshops/{id}/invoices/upcoming`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a single workshop
         * @summary Get workshop by ID
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopByID: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkshopByID', 'id', id);
            const localVarPath = `/workshops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get workshop current subscription
         * @summary Get workshop subscription.
         * @param {string} id ID of workshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopSubscription: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWorkshopSubscription', 'id', id);
            const localVarPath = `/workshops/{id}/subscriptions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of all subscriptions, sorted ascending by created_at (oldest first). They can be filtered by tenant.
         * @summary List all subscriptions.
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions: (paginationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all cars of a workshop
         * @summary List cars of a workshop
         * @param {string} id ID of workshop to return cars for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [ownerId] ID of owner to return cars for
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopCars: (id, paginationToken, search, ownerId, carIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopCars', 'id', id);
            const localVarPath = `/workshops/{id}/cars`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }
            if (carIds !== undefined) {
                localVarQueryParameter['carIds'] = carIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all tales of a workshop
         * @summary List tales of a workshop
         * @param {string} id ID of workshop to return tales for
         * @param {TaleStatus} [status]
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopTales: (id, status, carIds, search, paginationToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopTales', 'id', id);
            const localVarPath = `/workshops/{id}/tales`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (carIds !== undefined) {
                localVarQueryParameter['carIds'] = carIds;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all users of a workshop
         * @summary List users of a workshop
         * @param {string} id ID of workshop to return users for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [userIds] comma separated list of user IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopUsers: (id, paginationToken, search, userIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listWorkshopUsers', 'id', id);
            const localVarPath = `/workshops/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paginationToken !== undefined) {
                localVarQueryParameter['paginationToken'] = paginationToken;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (userIds !== undefined) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all workshops from the system that the user has access to, optionally filtered
         * @summary List workshops
         * @param {number} lat
         * @param {number} lng
         * @param {ListWorkshopsSortByEnum} sortBy sort by field:
         * @param {boolean} [isFeatured]
         * @param {string} [tags] tags to filter by, format is key1&#x3D;value1;key2&#x3D;value2. Should be url encoded.
         * @param {string} [services] services to filter by, format is service1;service2;serice3. Should be url encoded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshops: (lat, lng, sortBy, isFeatured, tags, services, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'lat' is not null or undefined
            assertParamExists('listWorkshops', 'lat', lat);
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('listWorkshops', 'lng', lng);
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('listWorkshops', 'sortBy', sortBy);
            const localVarPath = `/workshops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (services !== undefined) {
                localVarQueryParameter['services'] = services;
            }
            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }
            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Redeem a code for workshop
         * @summary Redeem a code
         * @param {string} id ID of workshop
         * @param {RedeemCodeRequest} redeemCodeRequest Redeem code request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode: (id, redeemCodeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redeemCode', 'id', id);
            // verify required parameter 'redeemCodeRequest' is not null or undefined
            assertParamExists('redeemCode', 'redeemCodeRequest', redeemCodeRequest);
            const localVarPath = `/workshops/{id}/redemptions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication publicJWT required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(redeemCodeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WorkshopApi - functional programming interface
 * @export
 */
export const WorkshopApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkshopApiAxiosParamCreator(configuration);
    return {
        /**
         * Create checkout session
         * @summary Create checkout session
         * @param {string} id ID of workshop
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest Create checkout session request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(id, createCheckoutSessionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCheckoutSession(id, createCheckoutSessionRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * enrolls a new workshop in the system
         * @summary Register workshop
         * @param {CreateWorkshopRequest} createWorkshopRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshop(createWorkshopRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWorkshop(createWorkshopRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create workshop user
         * @summary create workshop user
         * @param {string} id ID of workshop
         * @param {CreateUserRequest} createUserRequest User creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUser(id, createUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWorkshopUser(id, createUserRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get workshop\'s invoices
         * @summary Get workshop\'s invoices
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvoices(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get workshop\'s upcoming invoice
         * @summary Get workshop\'s upcoming invoice
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUpcomingInvoice(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns a single workshop
         * @summary Get workshop by ID
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopByID(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkshopByID(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get workshop current subscription
         * @summary Get workshop subscription.
         * @param {string} id ID of workshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopSubscription(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkshopSubscription(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve a list of all subscriptions, sorted ascending by created_at (oldest first). They can be filtered by tenant.
         * @summary List all subscriptions.
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions(paginationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSubscriptions(paginationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all cars of a workshop
         * @summary List cars of a workshop
         * @param {string} id ID of workshop to return cars for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [ownerId] ID of owner to return cars for
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopCars(id, paginationToken, search, ownerId, carIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopCars(id, paginationToken, search, ownerId, carIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all tales of a workshop
         * @summary List tales of a workshop
         * @param {string} id ID of workshop to return tales for
         * @param {TaleStatus} [status]
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopTales(id, status, carIds, search, paginationToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopTales(id, status, carIds, search, paginationToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all users of a workshop
         * @summary List users of a workshop
         * @param {string} id ID of workshop to return users for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [userIds] comma separated list of user IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopUsers(id, paginationToken, search, userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshopUsers(id, paginationToken, search, userIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Returns all workshops from the system that the user has access to, optionally filtered
         * @summary List workshops
         * @param {number} lat
         * @param {number} lng
         * @param {ListWorkshopsSortByEnum} sortBy sort by field:
         * @param {boolean} [isFeatured]
         * @param {string} [tags] tags to filter by, format is key1&#x3D;value1;key2&#x3D;value2. Should be url encoded.
         * @param {string} [services] services to filter by, format is service1;service2;serice3. Should be url encoded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Redeem a code for workshop
         * @summary Redeem a code
         * @param {string} id ID of workshop
         * @param {RedeemCodeRequest} redeemCodeRequest Redeem code request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode(id, redeemCodeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redeemCode(id, redeemCodeRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WorkshopApi - factory interface
 * @export
 */
export const WorkshopApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkshopApiFp(configuration);
    return {
        /**
         * Create checkout session
         * @summary Create checkout session
         * @param {string} id ID of workshop
         * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest Create checkout session request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(id, createCheckoutSessionRequest, options) {
            return localVarFp.createCheckoutSession(id, createCheckoutSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * enrolls a new workshop in the system
         * @summary Register workshop
         * @param {CreateWorkshopRequest} createWorkshopRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshop(createWorkshopRequest, options) {
            return localVarFp.createWorkshop(createWorkshopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create workshop user
         * @summary create workshop user
         * @param {string} id ID of workshop
         * @param {CreateUserRequest} createUserRequest User creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkshopUser(id, createUserRequest, options) {
            return localVarFp.createWorkshopUser(id, createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get workshop\'s invoices
         * @summary Get workshop\'s invoices
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(id, options) {
            return localVarFp.getInvoices(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get workshop\'s upcoming invoice
         * @summary Get workshop\'s upcoming invoice
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingInvoice(id, options) {
            return localVarFp.getUpcomingInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single workshop
         * @summary Get workshop by ID
         * @param {string} id ID of workshop to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopByID(id, options) {
            return localVarFp.getWorkshopByID(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get workshop current subscription
         * @summary Get workshop subscription.
         * @param {string} id ID of workshop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkshopSubscription(id, options) {
            return localVarFp.getWorkshopSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of all subscriptions, sorted ascending by created_at (oldest first). They can be filtered by tenant.
         * @summary List all subscriptions.
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions(paginationToken, options) {
            return localVarFp.listSubscriptions(paginationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all cars of a workshop
         * @summary List cars of a workshop
         * @param {string} id ID of workshop to return cars for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [ownerId] ID of owner to return cars for
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopCars(id, paginationToken, search, ownerId, carIds, options) {
            return localVarFp.listWorkshopCars(id, paginationToken, search, ownerId, carIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all tales of a workshop
         * @summary List tales of a workshop
         * @param {string} id ID of workshop to return tales for
         * @param {TaleStatus} [status]
         * @param {string} [carIds] comma separated list of car IDs to filter by
         * @param {string} [search]
         * @param {string} [paginationToken] This is the pagination token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopTales(id, status, carIds, search, paginationToken, options) {
            return localVarFp.listWorkshopTales(id, status, carIds, search, paginationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all users of a workshop
         * @summary List users of a workshop
         * @param {string} id ID of workshop to return users for
         * @param {string} [paginationToken] This is the pagination token
         * @param {string} [search] Search string
         * @param {string} [userIds] comma separated list of user IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshopUsers(id, paginationToken, search, userIds, options) {
            return localVarFp.listWorkshopUsers(id, paginationToken, search, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all workshops from the system that the user has access to, optionally filtered
         * @summary List workshops
         * @param {number} lat
         * @param {number} lng
         * @param {ListWorkshopsSortByEnum} sortBy sort by field:
         * @param {boolean} [isFeatured]
         * @param {string} [tags] tags to filter by, format is key1&#x3D;value1;key2&#x3D;value2. Should be url encoded.
         * @param {string} [services] services to filter by, format is service1;service2;serice3. Should be url encoded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options) {
            return localVarFp.listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options).then((request) => request(axios, basePath));
        },
        /**
         * Redeem a code for workshop
         * @summary Redeem a code
         * @param {string} id ID of workshop
         * @param {RedeemCodeRequest} redeemCodeRequest Redeem code request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCode(id, redeemCodeRequest, options) {
            return localVarFp.redeemCode(id, redeemCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkshopApi - object-oriented interface
 * @export
 * @class WorkshopApi
 * @extends {BaseAPI}
 */
export class WorkshopApi extends BaseAPI {
    /**
     * Create checkout session
     * @summary Create checkout session
     * @param {string} id ID of workshop
     * @param {CreateCheckoutSessionRequest} createCheckoutSessionRequest Create checkout session request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    createCheckoutSession(id, createCheckoutSessionRequest, options) {
        return WorkshopApiFp(this.configuration).createCheckoutSession(id, createCheckoutSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * enrolls a new workshop in the system
     * @summary Register workshop
     * @param {CreateWorkshopRequest} createWorkshopRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    createWorkshop(createWorkshopRequest, options) {
        return WorkshopApiFp(this.configuration).createWorkshop(createWorkshopRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create workshop user
     * @summary create workshop user
     * @param {string} id ID of workshop
     * @param {CreateUserRequest} createUserRequest User creation Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    createWorkshopUser(id, createUserRequest, options) {
        return WorkshopApiFp(this.configuration).createWorkshopUser(id, createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get workshop\'s invoices
     * @summary Get workshop\'s invoices
     * @param {string} id ID of workshop to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    getInvoices(id, options) {
        return WorkshopApiFp(this.configuration).getInvoices(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get workshop\'s upcoming invoice
     * @summary Get workshop\'s upcoming invoice
     * @param {string} id ID of workshop to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    getUpcomingInvoice(id, options) {
        return WorkshopApiFp(this.configuration).getUpcomingInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a single workshop
     * @summary Get workshop by ID
     * @param {string} id ID of workshop to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    getWorkshopByID(id, options) {
        return WorkshopApiFp(this.configuration).getWorkshopByID(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get workshop current subscription
     * @summary Get workshop subscription.
     * @param {string} id ID of workshop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    getWorkshopSubscription(id, options) {
        return WorkshopApiFp(this.configuration).getWorkshopSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of all subscriptions, sorted ascending by created_at (oldest first). They can be filtered by tenant.
     * @summary List all subscriptions.
     * @param {string} [paginationToken] This is the pagination token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    listSubscriptions(paginationToken, options) {
        return WorkshopApiFp(this.configuration).listSubscriptions(paginationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all cars of a workshop
     * @summary List cars of a workshop
     * @param {string} id ID of workshop to return cars for
     * @param {string} [paginationToken] This is the pagination token
     * @param {string} [search] Search string
     * @param {string} [ownerId] ID of owner to return cars for
     * @param {string} [carIds] comma separated list of car IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    listWorkshopCars(id, paginationToken, search, ownerId, carIds, options) {
        return WorkshopApiFp(this.configuration).listWorkshopCars(id, paginationToken, search, ownerId, carIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all tales of a workshop
     * @summary List tales of a workshop
     * @param {string} id ID of workshop to return tales for
     * @param {TaleStatus} [status]
     * @param {string} [carIds] comma separated list of car IDs to filter by
     * @param {string} [search]
     * @param {string} [paginationToken] This is the pagination token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    listWorkshopTales(id, status, carIds, search, paginationToken, options) {
        return WorkshopApiFp(this.configuration).listWorkshopTales(id, status, carIds, search, paginationToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all users of a workshop
     * @summary List users of a workshop
     * @param {string} id ID of workshop to return users for
     * @param {string} [paginationToken] This is the pagination token
     * @param {string} [search] Search string
     * @param {string} [userIds] comma separated list of user IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    listWorkshopUsers(id, paginationToken, search, userIds, options) {
        return WorkshopApiFp(this.configuration).listWorkshopUsers(id, paginationToken, search, userIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns all workshops from the system that the user has access to, optionally filtered
     * @summary List workshops
     * @param {number} lat
     * @param {number} lng
     * @param {ListWorkshopsSortByEnum} sortBy sort by field:
     * @param {boolean} [isFeatured]
     * @param {string} [tags] tags to filter by, format is key1&#x3D;value1;key2&#x3D;value2. Should be url encoded.
     * @param {string} [services] services to filter by, format is service1;service2;serice3. Should be url encoded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options) {
        return WorkshopApiFp(this.configuration).listWorkshops(lat, lng, sortBy, isFeatured, tags, services, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Redeem a code for workshop
     * @summary Redeem a code
     * @param {string} id ID of workshop
     * @param {RedeemCodeRequest} redeemCodeRequest Redeem code request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkshopApi
     */
    redeemCode(id, redeemCodeRequest, options) {
        return WorkshopApiFp(this.configuration).redeemCode(id, redeemCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ListWorkshopsSortByEnum = {
    Distance: 'distance',
    Rating: 'rating'
};
